/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Offline_Banner_BodyInputs */



/**
* | output |
* | --- |
* | "This meeting has no online link. Record the conversation with this device's microphone and Wundo writes the report." |
*
* @param {Meeting_Offline_Banner_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_offline_banner_body = /** @type {((inputs?: Meeting_Offline_Banner_BodyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Offline_Banner_BodyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Deze afspraak heeft geen online link. Neem het gesprek op met de micro van dit toestel, dan schrijft Wundo het verslag.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ce rendez-vous n'a pas de lien en ligne. Enregistrez la conversation avec le micro de cet appareil, et Wundo rédige le compte rendu.")
	return /** @type {LocalizedString} */ ("This meeting has no online link. Record the conversation with this device's microphone and Wundo writes the report.")
});